import { Card, CardContent, Typography, Grid} from '@mui/material';
import PaceGauge from './PaceGauge';
import { useTheme } from "@mui/material";

export default function PaceSubCard() {

  const theme = useTheme();
  // Base card style
  const baseCardStyles = {width: { xs: 400, md: 420, lg:500 }, borderRadius: "12px", }
  const cardStyles =
      theme.palette.mode === "light" ? {bgcolor: 'grey.C100', borderColor: 'grey.C900',} : 
        {bgcolor: 'greydark.C970', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)', // Safari
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.6)',};
  
  
  const pace = 0.8
  const warning_low = 1;
  const warning_red = 1.1;

    return(

<Card
            variant="outlined"
            sx={{
            width: '100%',
            borderRadius: 2,
            boxShadow: 'none',
            borderColor: theme.palette.mode === 'light' ? 'grey.C400' : 'greydark.C400',
            backgroundColor: theme.palette.mode === 'light' ? 'grey.C100' : 'greydark.C970',
            }}
            >
        
        <Grid container sx={{width: '100%', p:1.3, flex: 1, minWidth: 0}}>
               <Grid size={6} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>

                  <Grid container sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', }}>
                        <Grid size={12} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'  }}>
                                <Typography variant="h5" sx={{ display: 'block', fontWeight: 400, letterSpacing: 0.3 }}>
                                PACE OF AGING
                                </Typography>
                        </Grid>
            
                    <Grid size={12} sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 300 }}>
                                 Yearly Aging Speed
                            </Typography>
                    </Grid>

                  </Grid>
               </Grid>

            <Grid size={6} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', }}>
              
                <Grid container sx={{width: '100%', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', }}>
                
                  <Grid size={11} sx={{ display: 'flex', justifyContent:'flex-end', alignItems: 'center', gap: 1 }}>
                    <Typography variant="number" component="div"
                      sx={{ fontWeight: 400, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {pace}
                    </Typography>
                    
                    {/* severity indicator dot */}
                    <Grid size={1}
                      sx={{
                        width: 10,
                        height: 10,
                        borderRadius: '50%',
                        backgroundColor: 'traffic.green',
                        boxShadow: `0 0 0 4px ${theme.palette.traffic.green}22`, // subtle halo
                        ml: 1,
                      }}
                    />
                  </Grid>
                 </Grid>

              </Grid>

  </Grid>
</Card>
    
    )
}